import { FC } from "react";
import { IControlAttributes } from "../../../base/models";
import { useIPAddress } from "./useIPAddress";
import { FetchStatus } from "../../../base/types";
import { Badge, ErrorMessage, Spinner } from "../../../widgets";

export const DraftIPAddress: FC<IControlAttributes> = ({
    control, className, children, props, designerMode, ...rest
}) => {
    const { status, error } = useIPAddress(props);

    switch (status) {
        case FetchStatus.Idle: return <></>
        case FetchStatus.Loading: return <Spinner show={true} />
        case FetchStatus.Error: return <ErrorMessage message={error} />
    }

    return (
        <div className={"inline-block position-relative"}>
            <Badge
                className={"position-absolute top-0 end-0 text-nowrap fs-9 rounded-0"}
                badgeStyle="primary">
                IP Filter
            </Badge>
            <div className={className}>
                {children}
            </div>
        </div>)
}

